import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderFormComponent } from 'src/app/components/routes/order-form/order-form.component';
import { PurchaseHomeComponent } from './components/purchase-home/purchase-home.component';
import { OrderDeactivateGuard } from 'src/app/security/order-deactivate.guard';

const routes: Routes = [
  {
    path: '',
    component: PurchaseHomeComponent
  },
  {
    path: ':system',
    component: OrderFormComponent,
    canDeactivate: [OrderDeactivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PurchaseRoutingModule { }

